export default "__VITE_ASSET__wBaoTJPl__"